<tec-tile>
	<tec-tabs [tabs]="tabs()" type="pills" (tabSelected)="onTabSelected($event)" />
	<div [hidden]="selectedTabId() !== 'rejection_reasons'">
		<app-rejection-reasons />
	</div>
	<div [hidden]="selectedTabId() !== 'nationalities'">
		<app-top-nationalities [embedded]="true" />
	</div>
</tec-tile>
